import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-cchs-girls',
    templateUrl: './cchs-girls.component.html',
    styleUrls: ['./cchs-girls.component.css'],
    standalone: false
})
export class CchsGirlsComponent implements OnInit {

  // constructor() { }

   ngOnInit() {
   }

}
